(function ($, Drupal, settings) {
	"use strict";
	if ($('.on-page').length > 0) {
		var offset = $('.on-page').offset().top;
		setTimeout(function(){
			$('.on-page-items a').each(function(){
				var item = $(this),
						href = item.attr('href'),
						url = window.location.hash,
						position = $('#' + href.replace('#', '')).offset().top,
						height = $('#' + href.replace('#', '')).height();
				if (href == url) {
					$(this).addClass('active');
				};
				$(window).on('scroll', function (){
					var window_scroll = $(window).scrollTop();
					if((window_scroll + 150) > position && window_scroll < (position + height - 150)) {
						$('.on-page-items a').removeClass('active');
						item.addClass('active');
					}
				})
			});
		}, 500);
	};
	$(window).scroll(function(){
		var scroll = $(window).scrollTop();
		$('header').toggleClass('active', scroll > 150);
		$('.back-top').toggleClass('active', scroll > 450);
		if (scroll > offset - 50) {
			$('.on-page').addClass('active');
		} else {
			$('.on-page').removeClass('active');
		};
	});
	$('.header-hamburger').click(function(){
		$(this).toggleClass('active');
		$('.header-menu, html, body').toggleClass('active');
		$('header').toggleClass('menu-open');
	});
	$('body').on('mouseup', function(e){
		var div = $('.header-menu, .header-hamburger, .popup .desc, .modal-info, .header-search');
		if (!div.is(e.target) && div.has(e.target).length === 0) {
			$('html, body, .popup').removeClass('active');
			$(div).removeClass('active');
			$('.modal-info').dialog('close');
			$('header').removeClass('menu-open');
		};
	});
	$('.header-menu .sub-menu a').click(function(){
		$('html, body, .header-menu, .header-hamburger').removeClass('active');
	});
	$('.references-btn-show div').click(function(){
		$(this).parent().toggleClass('active');
		$(this).parent().siblings('.desc').toggleClass('active');
	});
	if ($(window).width() < 960) {
		$('.header-menu li.has-sub-menu > a').click(function(e){
			e.preventDefault();
		});
		$('.header-menu li.has-sub-menu span:last-child, .header-menu li.has-sub-menu svg').click(function(){
			$(this).parents('.has-sub-menu').toggleClass('menu-active');
			$('.header-menu').toggleClass('sub-menu-active');
		});
	};
	$('.header-menu li.has-sub-menu span:first-child').click(function(){
		window.location = $(this).parent().attr('href');
	});

	$('a:not(.popup-btn):not(.exclude-from-preventing):not([href^="tel:"]):not([href^="mailto:"])').click(function(e){
		const href = $(this)[0]['href'],
				  url = window.location.host;
		if (href.indexOf(url) < 0) {
			e.preventDefault();
			$('.popup').addClass('active');
			$('.popup-btn').attr('href', href);
		}
	});

	$('.popup .btn-hover, .popup .close').click(function(e){
		$('.popup').removeClass('active');
	});
	jQuery('a[href*="#"]:not(.scroll-false)').on('click', function() {
		var href = '#' + jQuery(this).attr('href').split('#')[1];
		if ($('.on-page').length > 0 && !$('.on-page').hasClass('active') && $(window).width() < 760) {
			jQuery('html, body').animate({
				scrollTop: jQuery(href).offset().top - 350
			});
		} else {
			jQuery('html, body').animate({
				scrollTop: jQuery(href).offset().top - 100
			});
		}
		return false;
	});
	$('.footer-btn').click(function(){
		var text = $(this).find('span').text();
		$(this).toggleClass('active');
		$('.footer-desc').toggleClass('active');
		$(this).find('span').text(text == 'Read more' ? 'Read less' : 'Read more');
	});
	$('.back-top').click(function() {
		$('html, body').animate({ scrollTop: 0 }, 'slow');
		return false;
	});
	$('.modal-info').each(function(){
		if ($(this).parents('.esc-guidelines').length > 0) {
			$(this).dialog({
				autoOpen: false,
				classes: {
					'ui-dialog': 'esc-guidelines-modal'
				},
				open: function() {
					$('html, body').addClass('active');
				},
				close: function() {
					$('html, body').removeClass('active');
				}
			})
		} else {
			$(this).dialog({
				autoOpen: false,
				open: function() {
					$('html, body').addClass('active');
				},
				close: function() {
					$('html, body').removeClass('active');
				}
			})
		};
	});
	$('.more-info-btn').click(function(){
		var title = $(this).data('title');
		$('.modal-info[data-title="' + title + '"]').dialog('open');
	});
	$('.monitoring-btn div, .practice-item-btn div').click(function(){
		var text = $(this).find('span').text();
		$(this).parent().toggleClass('active');
		$(this).parent().siblings('.add-desc').toggleClass('active');
		$(this).find('span').text(text == 'Read more' ? 'Read less' : 'Read more');
	});
	$('.monitoring-ecg-item .img').click(function(){
		var src = $(this).find('img').attr('src'),
				new_src = $(this).data('gif-src');
		$(this).data('gif-src', src);
		$(this).find('img').attr('src', new_src);
	});
	$('.accordion').accordion({
		collapsible: true,
		heightStyle: 'content',
		active: false
	});
	var target = window.location.hash;
	if (target != ''){
		var $target = jQuery(target);
		jQuery('html, body').stop().animate({
			'scrollTop': $target.offset().top - 100
		});
	};
	if (target == '#ui-id-3') {
		$('#ui-id-3').trigger('click');
	};

	var practice_triangle = $('.practice-item .triangle-bottom img');
	if(practice_triangle.length > 0) {
		$('footer .triangle-top').css('top', '-8px');
		$('footer .triangle-top img').attr('src', $(practice_triangle).attr('src'));
	};
	$('.header-search-icon').click(function(){
		$(this).css('opacity', 0);
		$('.views-exposed-form').addClass('active');
	});
	$('body').on('mouseup', function(e){
		var div = $('.views-exposed-form');
		if (!div.is(e.target) && div.has(e.target).length === 0) {
			$(div).removeClass('active');
			$('.header-search-icon').css('opacity', 1);
		};
	});
	$('.views-exposed-form input[type="submit"]').val('');
	$(window).resize(function(){
		if($(window).width() > 960 && $('.header-menu').hasClass('active')) {
			$('html, body, .header-menu, .header-hamburger').removeClass('active');
			$('header').removeClass('menu-open');
			$('.header-menu').removeClass('sub-menu-active');
			$('.has-sub-menu').removeClass('menu-active');
		};
		if ($(window).width() < 760 && $('.hero-block').length > 0) {
			$('.hero-block').css('background-image', 'url(' + $('.hero-block').data('mobile-bg') +')');
		} else if ($(window).width() > 760 && $('.hero-block').length > 0) {
			$('.hero-block').css('background-image', 'url(' + $('.hero-block').data('bg') +')');
		};
	});
	if ($(window).width() < 760 && $('.hero-block').length > 0) {
		$('.hero-block').css('background-image', 'url(' + $('.hero-block').data('mobile-bg') +')');
	};
	if ($('.search-page .title').length > 0) {
		var text = window.location.search.replace('?keys=', '').replace(/&page.*$/, '').replaceAll('+', ' ').replaceAll('%20', ' ');
		$('.search-page .title span').text(text);
	};
	$('.raasi-ckd-item .accordion-title').click(function(){
		setTimeout(function(){
			var height = $('.raasi-ckd').outerHeight();
			$('.raasi-ckd .svg-item').css('height', height).css('width', 'auto');
			if (height > 1000) {
				$('.raasi-add-desc').css('margin-top', '-146px');
			} else {
				$('.raasi-add-desc').css('margin-top', '-99px');
			};
		}, 500);
	});

  //////////////////////////
  // login popup
  if(document.getElementById('login-popup')){
    // test did the visitor logged in before
    if(window.localStorage.getItem('logged') === null && window.localStorage.getItem('logged') !== 'yes') {
      // show the pop-up
      document.getElementById('login-popup').style.display = 'block';
      // disable page scroll
      document.documentElement.style.overflow = 'hidden';
      // click on "I am a health care professional"
      document.getElementById('iam-hcp-button').addEventListener('click', function () {
        // hide modal 1
        document.getElementById('modal-1-big-buttons-row').classList.add('hide-modal');
        // show modal 2
        document.getElementById('modal-2-big-buttons-row').classList.remove('hide-modal');
      });

      // click "Back" button
      document.getElementById('back-button').addEventListener('click', function () {
        // show modal 1
        document.getElementById('modal-1-big-buttons-row').classList.remove('hide-modal');
        // hide modal 2
        document.getElementById('modal-2-big-buttons-row').classList.add('hide-modal');
      });

      // click "Continue" button
      document.getElementById('continue-button').addEventListener('click', function () {
        // check the checkbox
        // and hide pop-up if checked
        if (document.getElementById('modal-2-checkbox').checked) {
          // hide pop-up
          document.getElementById('login-popup').style.display = 'none';
          // store in the localStore that the user is HCP
          window.localStorage.setItem('logged', 'yes');
          // unsable page scroll
          document.documentElement.style.overflow = 'auto';
        }
      });
    }
  }

  /////////////////////////////
  // add data attributes to elements that have "accordion-advanced" class
  const accordion_advanced = document.querySelectorAll('.accordion-advanced');

  for(let i=0; accordion_advanced.length > i; i++){
    accordion_advanced[i].setAttribute('data-event-action', window.location.pathname);

    // add the data attribute to the child of type img
    // if has class "to-add-event-action-img-child"
    const childImg = accordion_advanced[i].querySelector("img");

    childImg.setAttribute('data-event-action', window.location.pathname);
    childImg.setAttribute('data-event-label', accordion_advanced[i].dataset.eventLabel);
    childImg.setAttribute('data-event-category', accordion_advanced[i].dataset.eventCategory);
  }

  //////////////////////////
  // add data attribute to all elements with the class
  const allElements = document.querySelectorAll('.to-add-event-action');

  for(let i=0; allElements.length > i; i++){
    allElements[i].setAttribute('data-event-action', window.location.pathname);

    // add the data attribute to the child of type img
    // if has class "to-add-event-action-img-child"
    if(allElements[i].classList.contains("to-add-event-action-img-child")){
      const childImg = allElements[i].querySelector("img");

      childImg.setAttribute('data-event-action', window.location.pathname);
      childImg.setAttribute('data-event-label', allElements[i].dataset.eventLabel);
      childImg.setAttribute('data-event-category', allElements[i].dataset.eventCategory);
    }
  }

  //////////////////////////
  // add data attribute to the element
  // taking them from the p child
  const allEls = document.querySelectorAll('.add-data-attributes-from-child');

  for(let i=0; allEls.length > i; i++){
    const p_child = allEls[i].querySelector('p');

    allEls[i].setAttribute('data-event-action', p_child.dataset.eventAction);
    allEls[i].setAttribute('data-event-label', p_child.dataset.eventLabel);
    allEls[i].setAttribute('data-event-category', p_child.dataset.eventCategory);
  }

})(jQuery, Drupal, drupalSettings);
